module.exports = __webpack_public_path__ + "fonts/iconfont.3e1f1f2a.ttf";